/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { Vector2dPb } from "../eigen_lcm/Vector2d";
import { Vector3fPb } from "../eigen_lcm/Vector3f";
import { PolygonPrism } from "../scan_planner/polygon_prism";
import { SingleOrbitRequest } from "../scan_planner/single_orbit_request";
import { Structure } from "../structure/structure";
import { GpsHelperState } from "./gps_helper_state";
import {
  RelocalizationStrategy_Enum,
  relocalizationStrategy_EnumFromJSON,
  relocalizationStrategy_EnumToJSON,
} from "./relocalization_strategy";

export const protobufPackage = "surface_scan";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface InspectionParameters {
  polygonPrism: PolygonPrism | undefined;
  focusPoint: Vector3fPb | undefined;
  viewpointCandidates: Vector3fPb[];
  viewpointFocusPoint: Vector3fPb | undefined;
  gpsHelper: GpsHelperState | undefined;
  relocalizationStrategy: RelocalizationStrategy_Enum;
  singleOrbitRequests: SingleOrbitRequest[];
  structures: Structure[];
  globalMapTColumnPositionsXy: Vector2dPb[];
  dtedSourceFiles: string[];
}

function createBaseInspectionParameters(): InspectionParameters {
  return {
    polygonPrism: undefined,
    focusPoint: undefined,
    viewpointCandidates: [],
    viewpointFocusPoint: undefined,
    gpsHelper: undefined,
    relocalizationStrategy: 0,
    singleOrbitRequests: [],
    structures: [],
    globalMapTColumnPositionsXy: [],
    dtedSourceFiles: [],
  };
}

export const InspectionParameters = {
  encode(message: InspectionParameters, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.polygonPrism !== undefined) {
      PolygonPrism.encode(message.polygonPrism, writer.uint32(10).fork()).ldelim();
    }
    if (message.focusPoint !== undefined) {
      Vector3fPb.encode(message.focusPoint, writer.uint32(50).fork()).ldelim();
    }
    for (const v of message.viewpointCandidates) {
      Vector3fPb.encode(v!, writer.uint32(74).fork()).ldelim();
    }
    if (message.viewpointFocusPoint !== undefined) {
      Vector3fPb.encode(message.viewpointFocusPoint, writer.uint32(82).fork()).ldelim();
    }
    if (message.gpsHelper !== undefined) {
      GpsHelperState.encode(message.gpsHelper, writer.uint32(90).fork()).ldelim();
    }
    if (message.relocalizationStrategy !== 0) {
      writer.uint32(96).int32(message.relocalizationStrategy);
    }
    for (const v of message.singleOrbitRequests) {
      SingleOrbitRequest.encode(v!, writer.uint32(114).fork()).ldelim();
    }
    for (const v of message.structures) {
      Structure.encode(v!, writer.uint32(122).fork()).ldelim();
    }
    for (const v of message.globalMapTColumnPositionsXy) {
      Vector2dPb.encode(v!, writer.uint32(130).fork()).ldelim();
    }
    for (const v of message.dtedSourceFiles) {
      writer.uint32(138).string(v!);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): InspectionParameters {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInspectionParameters();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.polygonPrism = PolygonPrism.decode(reader, reader.uint32());
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.focusPoint = Vector3fPb.decode(reader, reader.uint32());
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.viewpointCandidates.push(Vector3fPb.decode(reader, reader.uint32()));
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.viewpointFocusPoint = Vector3fPb.decode(reader, reader.uint32());
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.gpsHelper = GpsHelperState.decode(reader, reader.uint32());
          continue;
        case 12:
          if (tag !== 96) {
            break;
          }

          message.relocalizationStrategy = reader.int32() as any;
          continue;
        case 14:
          if (tag !== 114) {
            break;
          }

          message.singleOrbitRequests.push(SingleOrbitRequest.decode(reader, reader.uint32()));
          continue;
        case 15:
          if (tag !== 122) {
            break;
          }

          message.structures.push(Structure.decode(reader, reader.uint32()));
          continue;
        case 16:
          if (tag !== 130) {
            break;
          }

          message.globalMapTColumnPositionsXy.push(Vector2dPb.decode(reader, reader.uint32()));
          continue;
        case 17:
          if (tag !== 138) {
            break;
          }

          message.dtedSourceFiles.push(reader.string());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InspectionParameters {
    return {
      polygonPrism: isSet(object.polygonPrism) ? PolygonPrism.fromJSON(object.polygonPrism) : undefined,
      focusPoint: isSet(object.focusPoint) ? Vector3fPb.fromJSON(object.focusPoint) : undefined,
      viewpointCandidates: globalThis.Array.isArray(object?.viewpointCandidates)
        ? object.viewpointCandidates.map((e: any) => Vector3fPb.fromJSON(e))
        : [],
      viewpointFocusPoint: isSet(object.viewpointFocusPoint)
        ? Vector3fPb.fromJSON(object.viewpointFocusPoint)
        : undefined,
      gpsHelper: isSet(object.gpsHelper) ? GpsHelperState.fromJSON(object.gpsHelper) : undefined,
      relocalizationStrategy: isSet(object.relocalizationStrategy)
        ? relocalizationStrategy_EnumFromJSON(object.relocalizationStrategy)
        : 0,
      singleOrbitRequests: globalThis.Array.isArray(object?.singleOrbitRequests)
        ? object.singleOrbitRequests.map((e: any) => SingleOrbitRequest.fromJSON(e))
        : [],
      structures: globalThis.Array.isArray(object?.structures)
        ? object.structures.map((e: any) => Structure.fromJSON(e))
        : [],
      globalMapTColumnPositionsXy: globalThis.Array.isArray(object?.globalMapTColumnPositionsXy)
        ? object.globalMapTColumnPositionsXy.map((e: any) => Vector2dPb.fromJSON(e))
        : [],
      dtedSourceFiles: globalThis.Array.isArray(object?.dtedSourceFiles)
        ? object.dtedSourceFiles.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: InspectionParameters): unknown {
    const obj: any = {};
    if (message.polygonPrism !== undefined) {
      obj.polygonPrism = PolygonPrism.toJSON(message.polygonPrism);
    }
    if (message.focusPoint !== undefined) {
      obj.focusPoint = Vector3fPb.toJSON(message.focusPoint);
    }
    if (message.viewpointCandidates?.length) {
      obj.viewpointCandidates = message.viewpointCandidates.map((e) => Vector3fPb.toJSON(e));
    }
    if (message.viewpointFocusPoint !== undefined) {
      obj.viewpointFocusPoint = Vector3fPb.toJSON(message.viewpointFocusPoint);
    }
    if (message.gpsHelper !== undefined) {
      obj.gpsHelper = GpsHelperState.toJSON(message.gpsHelper);
    }
    if (message.relocalizationStrategy !== 0) {
      obj.relocalizationStrategy = relocalizationStrategy_EnumToJSON(message.relocalizationStrategy);
    }
    if (message.singleOrbitRequests?.length) {
      obj.singleOrbitRequests = message.singleOrbitRequests.map((e) => SingleOrbitRequest.toJSON(e));
    }
    if (message.structures?.length) {
      obj.structures = message.structures.map((e) => Structure.toJSON(e));
    }
    if (message.globalMapTColumnPositionsXy?.length) {
      obj.globalMapTColumnPositionsXy = message.globalMapTColumnPositionsXy.map((e) => Vector2dPb.toJSON(e));
    }
    if (message.dtedSourceFiles?.length) {
      obj.dtedSourceFiles = message.dtedSourceFiles;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InspectionParameters>, I>>(base?: I): InspectionParameters {
    return InspectionParameters.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InspectionParameters>, I>>(object: I): InspectionParameters {
    const message = createBaseInspectionParameters();
    message.polygonPrism = (object.polygonPrism !== undefined && object.polygonPrism !== null)
      ? PolygonPrism.fromPartial(object.polygonPrism)
      : undefined;
    message.focusPoint = (object.focusPoint !== undefined && object.focusPoint !== null)
      ? Vector3fPb.fromPartial(object.focusPoint)
      : undefined;
    message.viewpointCandidates = object.viewpointCandidates?.map((e) => Vector3fPb.fromPartial(e)) || [];
    message.viewpointFocusPoint = (object.viewpointFocusPoint !== undefined && object.viewpointFocusPoint !== null)
      ? Vector3fPb.fromPartial(object.viewpointFocusPoint)
      : undefined;
    message.gpsHelper = (object.gpsHelper !== undefined && object.gpsHelper !== null)
      ? GpsHelperState.fromPartial(object.gpsHelper)
      : undefined;
    message.relocalizationStrategy = object.relocalizationStrategy ?? 0;
    message.singleOrbitRequests = object.singleOrbitRequests?.map((e) => SingleOrbitRequest.fromPartial(e)) || [];
    message.structures = object.structures?.map((e) => Structure.fromPartial(e)) || [];
    message.globalMapTColumnPositionsXy = object.globalMapTColumnPositionsXy?.map((e) => Vector2dPb.fromPartial(e)) ||
      [];
    message.dtedSourceFiles = object.dtedSourceFiles?.map((e) => e) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
